var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data}},[_c('template',{slot:"footer"},[_vm._v(" 订单总数:xxxxx累计金额:xxx上次消费时间:xxxx ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }